import { Grid, TextField } from '@material-ui/core';
import helpers from 'app/utils/helpers';
import React from 'react';

const CompanyData = ({ companyData }) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label={companyData.deCpfCnpj && companyData.deCpfCnpj.length < 14 ? 'CPF' : 'CNPJ'}
                    name="cnpj"
                    value={
                        companyData.deCnpjMatriz
                            ? helpers.formatarDocumento(companyData.deCnpjMatriz)
                            : companyData.deCpfCnpj
                              ? helpers.formatarDocumento(companyData.deCpfCnpj)
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label={companyData.deCpfCnpj && companyData.deCpfCnpj.length < 14 ? 'Nome' : 'Razão Social'}
                    name="razao_social"
                    value={
                        companyData.deRazaoSocial
                            ? companyData.deRazaoSocial
                            : companyData.nmUsuario
                              ? companyData.nmUsuario
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={2}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="CEP"
                    name="cep"
                    value={
                        companyData.enderecoMatriz?.deCep
                            ? helpers.formatarCep(companyData.enderecoMatriz?.deCep)
                            : companyData.deCep
                              ? helpers.formatarCep(companyData.deCep)
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="UF"
                    name="uf"
                    value={
                        companyData.enderecoMatriz?.municipio?.uf?.sgUf
                            ? companyData.enderecoMatriz?.municipio?.uf?.sgUf
                            : companyData.municipio?.uf?.sgUf
                              ? companyData.municipio?.uf?.sgUf
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Município"
                    name="municipio"
                    value={
                        companyData.enderecoMatriz?.municipio?.nmMunicipio
                            ? companyData.enderecoMatriz?.municipio?.nmMunicipio
                            : companyData.municipio?.nmMunicipio
                              ? companyData.municipio?.nmMunicipio
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Bairro"
                    name="bairro"
                    value={
                        companyData.enderecoMatriz?.deBairro
                            ? companyData.enderecoMatriz?.deBairro
                            : companyData.deBairro
                              ? companyData.deBairro
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Endereço"
                    name="endereco"
                    value={
                        companyData.enderecoMatriz?.deEndereco
                            ? companyData.enderecoMatriz?.deEndereco
                            : companyData.deEndereco
                              ? companyData.deEndereco
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Número"
                    name="numero"
                    value={
                        companyData.enderecoMatriz?.deNumeroEndereco
                            ? companyData.enderecoMatriz?.deNumeroEndereco
                            : companyData.deNumeroEndereco
                              ? companyData.deNumeroEndereco
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Complemento"
                    name="complemento"
                    value={
                        companyData.enderecoMatriz?.deComplemento
                            ? companyData.enderecoMatriz?.deComplemento
                            : companyData.deComplemento
                              ? companyData.deComplemento
                              : ''
                    }
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="E-mail"
                    name="email"
                    value={companyData.deEmail}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Telefone"
                    name="telefone"
                    value={companyData.deTelefone ? helpers.formatarTelefone(companyData.deTelefone) : ''}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    variant="filled"
                    fullWidth
                    minRows={4}
                    disabled
                    label="Observações"
                    name="observacoes"
                    value={companyData.deObservacao}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default CompanyData;
